import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'

const List = styled.ul`
  span {
    position: relative;
    top: -4px;
  }
  li:last-of-type {
    span {
      display: none;
    }
  }
`

const processName = personName => {
  const spaces = personName.split(' ')
  switch (spaces.length) {
    case 4:
      return `${spaces[0]} ${spaces[1]} <br /> ${spaces[2]} ${spaces[3]}`
    case 3:
      return `${spaces[0]} <br /> ${spaces[1]}  ${spaces[2]}`
    default:
      return personName
  }
}

const ProfileName = ({
  nombre,
  nombrenomina,
  distrito,
  escanoreservadosino,
  pueblooriginariosicorresponde,
  letralista,
  numerocandidato,
  sexo,
  elegido,
}) => {
  const { allGoogleSheetInfoDistritosRow } = useStaticQuery(graphql`
    query {
      allGoogleSheetInfoDistritosRow {
        nodes {
          comuna
          distrito
          region
        }
      }
    }
  `)

  const byDistrito = groupBy(allGoogleSheetInfoDistritosRow.nodes, 'distrito')

  return (
    <div className="profile-name">
      <h1
        className={`block mt-0 sm:mt-4 text-4xl leading-none sm:text-5xl ${
          nombre !== nombrenomina ? 'mb-0' : 'mb-3'
        }`}>
        <small className="font-sans text-xl font-light uppercase sm:text-2xl ">
          {elegido === 'Electo' ? (
            <span>constituyente {sexo === 'Mujer' ? 'Electa' : 'Electo'}</span>
          ) : (
            <span>
              {sexo === 'Mujer' ? 'Candidata' : 'Candidato'} a constituyente{' '}
            </span>
          )}
        </small>
        <strong
          className="block leading-none"
          dangerouslySetInnerHTML={{ __html: processName(nombrenomina) }}
        />
        <span className="font-normal leading-none">
          {' '}
          {letralista}-{numerocandidato}
        </span>
      </h1>
      {nombre !== nombrenomina && (
        <h2 className="mb-3 text-base font-bold leading-none">({nombre})</h2>
      )}
      {escanoreservadosino && escanoreservadosino === 'Sí' && (
        <h3 className="mb-2 text-2xl leading-none sm:text-3xl">
          Postuló por <strong>escaño reservado</strong>
          {pueblooriginariosicorresponde && (
            <>
              {' '}
              del pueblo <strong>{pueblooriginariosicorresponde} </strong>
            </>
          )}
        </h3>
      )}
      {!escanoreservadosino ||
        (escanoreservadosino !== 'Sí' && (
          <div className="mb-4 text-2xl leading-none sm:text-3xl">
            <p className="pb-0 mb-0 text-xl sm:text-2xl">
              Postuló por el <strong> Distrito {distrito}</strong>:
            </p>
            <List className="block gap-2 mt-2 text-xl">
              {Object.keys(groupBy(byDistrito[distrito], 'comuna')).map(
                comuna => {
                  return (
                    <li className="inline-block" key={comuna}>
                      {comuna}
                      <span className="mx-1">.</span>
                    </li>
                  )
                },
              )}
            </List>
          </div>
        ))}
    </div>
  )
}

const groupBy = (list, props) => {
  return list.reduce((a, b) => {
    ;(a[b[props]] = a[b[props]] || []).push(b)
    return a
  }, {})
}

export default ProfileName
